module.exports = "https://static.wagwalking.com/_next/static/images/wagcomparelogo-f29fa1ee5729d10588765b6058088214.svg";